/**
 * Cancel Request Error, thrown when request is cancel
 */
export default class CancelRequestError extends Error {
    /**
     * @param {string} description description
     */
    constructor(description) {
        super(description)
        this.name = this.constructor.name
    }
}
